import {createFileRoute} from "@tanstack/react-router";
import {expedientOffersMessages} from "../../-messages/expedient-customer-offers.messages";
import {ExpedientOffersPage} from "./-page/expedient-offers.page";
import {ExpedientOffersPending} from "./-page/expedient-offers.pending";
import {expedientOffersSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/expedients/$expedientId/offers/")({
  component: RouteComponent,
  pendingComponent: ExpedientOffersPending,
  validateSearch: expedientOffersSearchSchema,
  staticData: {meta: {labelDescriptor: expedientOffersMessages.title}},
});
function RouteComponent() {
  const {expedientId} = Route.useParams();
  return <ExpedientOffersPage expedientId={expedientId} />;
}
